/* Copyright (c) Trimble Inc. All rights reserved. */

// Initialize shared dependencies

import { initializeAuthDb } from '@tcp-base/authentication';
import 'reflect-metadata';
import { environment } from './environments/environment';

// Initialize the app
const init: () => Promise<void> = async (): Promise<void> => {
  try {
    if (environment.featureFlags.enableMswMocking) {
      const { worker } = await import('./mocks/browser');
      await worker.start({
        // 'bypass' allows unhandled requests to pass through to the real API
        onUnhandledRequest: 'bypass',
      });
      // eslint-disable-next-line no-console
      console.log('[MSW] Mock Service Worker started - mocking specific endpoints');
    }

    // Wait for database initialization before loading the app
    await initializeAuthDb();
    // Now load the bootstrap after DB is ready
    await import('./bootstrap.js');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error initializing app:', err);
  }
};

init();
